import * as React from "react";
import { Facebook, Instagram, Linkedin, Twitter, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { FormProvider } from "@/integrations/forms/FormProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="3328" className="flex flex-col gap-3 w-full">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-24 bg-muted-foreground/10 animate-pulse rounded-sm" />)}
      </div>;
  }
  const items = menuItems && menuItems.length > 0 ? menuItems : [{
    id: "home",
    label: "Home Base",
    href: "/HomePage"
  }, {
    id: "expertise",
    label: "The Rally Point",
    href: "/TheRallyPointPage"
  }, {
    id: "philosophy",
    label: "About Our Six",
    href: "/AboutOurSixPage"
  }, {
    id: "impact",
    label: "Support Resources",
    href: "/SupportResourcesPage"
  }, {
    id: "contact",
    label: "Contact HQ",
    href: "/ContactHQPage"
  }];
  return <NavigationMenu viewport={false} className="items-start justify-start max-w-full w-full block">
      <NavigationMenuList className="flex-col items-start space-x-0 gap-3 w-full">
        {items.map(item => <NavigationMenuItem key={item.id} className="w-full">
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-slate-400 hover:text-primary transition-colors text-sm block w-full text-left font-bold uppercase tracking-wider">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const businessName = "Paniolo Trails LLC";
  const missionStatement = "Veteran and first-responder owned. We are committed to combating suicide through community, awareness, and purpose-driven apparel. Got Your Six.";
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  return <footer id="basecamp-footer" className="dark bg-black pt-20 pb-10 border-t border-white/5">
      <div className="container mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570849/img/paniolo_trails_llc_logo.png" alt={`${businessName} Logo`} className="h-10 w-auto object-contain" />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs font-sans">
              {missionStatement}
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-sans font-black text-white uppercase tracking-tighter text-lg">Quick Links</h3>
            <MenuProvider menu_id="99" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-sans font-black text-white uppercase tracking-tighter text-lg">The Brotherhood</h3>
            <div className="flex flex-wrap gap-3">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} className="bg-white p-2.5 rounded-full text-black hover:bg-primary hover:text-white hover:shadow-lg transition-all duration-300 border-none flex items-center justify-center" aria-label={social.label}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-sans font-black text-white uppercase tracking-tighter text-lg">Join the Movement</h3>
            <p className="text-slate-400 text-sm leading-relaxed font-sans">
              Subscribe to our newsletter for mission updates and exclusive gear drops.
            </p>
            <FormProvider form_id="newsletter_subscription">
              <form className="flex flex-col gap-3" onSubmit={e => e.preventDefault()}>
                <Input type="email" name="email" placeholder="Enter your email" className="bg-secondary border-none focus-visible:ring-primary/40 h-12 rounded-sm text-white placeholder:text-slate-500" required />
                <Button type="submit" className="w-full h-12 cursor-pointer bg-primary hover:bg-primary/90 text-white font-black uppercase tracking-widest rounded-sm transition-all">
                  Join the Fight <Send className="ml-2 size-4" />
                </Button>
              </form>
            </FormProvider>
          </div>
        </div>

        <Separator className="bg-white/10 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] uppercase tracking-widest font-mono text-slate-500">
          <p className="flex items-center gap-2">
            &copy; {currentYear} {businessName}. Veteran Owned 
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}